<div *ngFor="let alert of alertsService.alerts">
  <p>{{alert.message}}</p>
  
</div>
